import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import useInlineEditBuffer from "@tailormed/common-client/component/inline-edit/hooks/useInlineEditBuffer";

import { selectProvidersFacility } from "../../../store/selector";
import FacilitiesSelectField from "../../Select/FacilitiesSelectField";
import getInlineEditPopupContainer from "@tailormed/common-client/component/inline-edit/getInlineEditPopupContainer";
import { useGetSetting } from "../../../hooks/getSetting";

const PatientFacilityInlineEditor = ({ value, onCommit, onCancel, autoFocus = true, placeholder }) => {
  const { t } = useTranslation();
  const facilities = useSelector(selectProvidersFacility);
  const [rawBillableFacilityIds] = useGetSetting(["billable-facilities"]);
  const billableFacilityIds = Array.isArray(rawBillableFacilityIds) ? rawBillableFacilityIds : [];

  const initialIds = Array.isArray(value) ? [...value] : value != null ? [value] : [];
  const { buffer, setBuffer, handleBlur, handleKeyDown } = useInlineEditBuffer({
    value: initialIds,
    onCommit,
    onCancel
  });

  return (
    <FacilitiesSelectField
      facilities={facilities || []}
      value={buffer}
      onChange={setBuffer}
      autoFocus={autoFocus}
      defaultOpen={autoFocus}
      placeholder={placeholder || t("inline_edit.facility_placeholder")}
      maxTagCount="responsive"
      maxTagPlaceholder={(omitted) => `+${omitted.length}`}
      bordered
      dropdownMatchSelectWidth={false}
      dropdownStyle={{ minWidth: 280, maxHeight: 240, overflowY: "auto" }}
      getPopupContainer={getInlineEditPopupContainer}
      style={{ width: "100%", minWidth: 140 }}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      nonRemovableFacilityIds={billableFacilityIds}
    />
  );
};

PatientFacilityInlineEditor.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  onCommit: PropTypes.func,
  onCancel: PropTypes.func,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.node
};

export default PatientFacilityInlineEditor;
